import ServicePageLayout from "./ServicePageLayout";

const BULLETS = [
  "Étude personnalisée de votre terrain",
  "Plan de plantation adapté au climat creusois",
  "Choix de végétaux locaux et durables",
  "Création de massifs, allées, terrasses",
  "Préparation des sols et plantations",
  "Conseils d'entretien après réalisation",
];

const PROCESS = [
  { title: "Rencontre & étude", desc: "Visite sur place, écoute de vos envies, analyse du terrain." },
  { title: "Devis & plan", desc: "Proposition détaillée avec esquisse, sans engagement." },
  { title: "Réalisation", desc: "Création soignée par nos équipes, respect des délais." },
];

export default function PaysagisteCreuse() {
  return (
    <ServicePageLayout
      slug="paysagiste-creuse"
      title="Paysagiste en Creuse — Création de jardin sur-mesure"
      seoTitle="Paysagiste Creuse (23) — Création jardin | K'REUSE EXTÉRIEUR"
      seoDescription="Paysagiste professionnel Creuse (23). Création jardin sur-mesure, aménagement extérieur, plantation. Devis gratuit sous 24h."
      badge="Paysagiste · Creuse 23"
      hero="K'REUSE EXTÉRIEUR conçoit et crée votre jardin selon vos envies, votre terrain et votre budget. Des espaces extérieurs uniques, durables et respectueux du vivant."
      intro="Chaque jardin est unique. Nous étudions votre terrain, écoutons vos envies, et vous proposons un projet sur-mesure : massifs, terrasse végétalisée, allées, espace détente ou potager. Notre savoir-faire local en Creuse garantit des plantations adaptées au climat et à la nature des sols."
      bullets={BULLETS}
      process={PROCESS}
      ctaTitle="Votre futur jardin commence ici"
      ctaDesc="Demandez votre devis gratuit. Réponse sous 24h."
      image="/img/photos/jardin-paysager.webp"
      whatsappText="Bonjour, je souhaite un devis pour la création de mon jardin (paysagiste)."
    />
  );
}
